module.exports = "<p>\r\n  report-fee-cancel works!\r\n</p>\r\n"